import { useIsCardPageV2Enabled } from '@repo/ccc-main-app-lib/src/lib/useIsCardPageV2Enabled.ts'
import { Loader } from '@repo/internal-tools-design-system/src/lib/Loader/Loader.tsx'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/user/$userId/live-pay/')({
  component: UserLivePayIndexPage,
})

function UserLivePayIndexPage() {
  const { userId } = Route.useParams()
  const navigate = useNavigate()

  const shouldUseCardPageV2 = useIsCardPageV2Enabled()

  useEffect(() => {
    void navigate({
      to: shouldUseCardPageV2
        ? '/user/$userId/live-pay/card-info'
        : '/user/$userId/card',
      params: { userId },
      replace: true,
    })
  }, [navigate, shouldUseCardPageV2, userId])

  return (
    <Loader size="sm" withContainer isFullPage>
      Redirecting...
    </Loader>
  )
}
